import { render, staticRenderFns } from "./NeoparentReportProblem.vue?vue&type=template&id=99a02400&scoped=true"
import script from "./NeoparentReportProblem.vue?vue&type=script&lang=js"
export * from "./NeoparentReportProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a02400",
  null
  
)

export default component.exports